<template>
	<form @submit.prevent="submit">
		<slot/>
		<div class="error" v-if="error.message" v-text="error.message"/>
		<div class="message" v-if="message" v-text="message"/>
	</form>
</template>

<script>
export default {
	props: {
		loading: {type: Boolean, required: true},
		message: {type: String, required: false},
		error: {type: Object, required: true}
	},
	methods: {
		submit() {
			if (!this.loading) {
				this.$emit("submit");
			}
		}
	}
};
</script>

<style lang="scss" scoped>
form {
	.error {
		color: $red1;
		font-size: 13px;
		margin: 1em 0;
		text-align: center;
	}

	.message {
		color: $green1;
		font-size: 13px;
		margin: 1em 0;
		text-align: center;
	}
}
</style>
